import { Paperclip } from 'lucide-react';

type EmailAttachment = {
  name: string;
  size: number;
  mimeType: string;
  storageKey?: string;
  url?: string;
};

interface EmailAttachmentListProps {
  attachments?: EmailAttachment[];
}

export function EmailAttachmentList({ attachments = [] }: EmailAttachmentListProps) {
  if (attachments.length === 0) {
    return null;
  }

  const toAbsoluteUrl = (attachment: EmailAttachment) => {
    if (attachment.url) {
      return attachment.url;
    }

    return null;
  };

  return (
    <div className="mt-4 border-b border-gray-200 py-2">
      <div className="flex flex-wrap gap-2">
        {attachments.map((attachment, index) => {
          const href = toAbsoluteUrl(attachment);

          const content = (
            <>
              <Paperclip className="h-4 w-4 shrink-0 text-gray-500" strokeWidth={2} />
              <span className="min-w-0 max-w-[170px] truncate text-base font-medium leading-6 text-gray-500">
                {attachment.name}
              </span>
            </>
          );

          if (!href) {
            return (
              <div
                key={`${attachment.name}-${index}`}
                className="inline-flex max-w-[250px] items-center gap-3 rounded-[28px] bg-gray-100 px-5 py-3 text-gray-400"
              >
                {content}
              </div>
            );
          }

          return (
            <a
              key={`${attachment.name}-${index}`}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex max-w-[250px] items-center gap-3 rounded-[28px] bg-gray-100 px-5 py-3 transition hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {content}
            </a>
          );
        })}
      </div>
    </div>
  );
}
